// Company insight slice

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";
import { IWebScrapData } from "../company-registration/companyRegistrationSlice";
import companyOnboardingQuestions, {
  IOnboardQuestion,
} from "../../data/onboardingQuestions";

export interface ICompanyOnboardInfo {
  currentStep: number;
  //answers?: { [key: string]: any };
  answers?: Record<number, string | string[]>;
  questions: IOnboardQuestion[];
}

const initialState: ICompanyOnboardInfo = {
  currentStep: 0,
  answers: {},
  questions: []// companyOnboardingQuestions,

};

export const companyOnboardWizardSlice = createSlice({
  name: "companyOnbarodWizard",
  initialState,
  reducers: {
    setAnswer(
      state,
      action: PayloadAction<{ step: number; answer: string | string[] }>
    ) {
      if (!state.answers) {
        state.answers = {}; // Initialize answers if undefined
      }
      state.answers[action.payload.step] = action.payload.answer;
    },
    nextStep(state) {
      state.currentStep += 1;
    },
    previousStep(state) {
      state.currentStep -= 1;
    },
    setStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    setQuestions(state, action: PayloadAction<IOnboardQuestion[]>){
      state.questions = action.payload;
    }
  },
});

export const { setAnswer, nextStep, previousStep, setStep, setQuestions } =
  companyOnboardWizardSlice.actions;
export const companyOnboardWizardSelector = (state: RootState) =>
  state.companyOnboardWizardReducer;
export default companyOnboardWizardSlice.reducer;
